import React, { Component } from 'react'

// lib
import { Row } from 'antd'

// redux
import { connect } from 'react-redux'

// subcomponent
import EventComponent from './event_component'

class ListEvents extends Component {
    render() {
        const { events } = this.props
        return (
            <Row className="ListEvent">
                {events.map((event, index) => {
                    return <EventComponent event={event} key={index} />
                })}
                {this.props.events.length === 0 && <text>Không có dữ liệu</text>}
            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        events: state.component_select_event.events,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListEvents)
